import type { Infer } from 'superstruct';
import {
	array,
	defaulted,
	enums,
	number,
	object,
	partial,
	string,
} from 'superstruct';

import {
	parsableArray,
	stringDate,
	userString,
	withMessage,
} from '@adflow/shared/util-superstruct';

const KeywordListDto = enums(['standard', 'negative']);

export const ViewKeywordDto = object({
	id: number(),
	name: string(),
	type: KeywordListDto,
	list: array(string()),

	createdAt: stringDate(),
	updatedAt: stringDate(),
});

export const AddKeywordDto = object({
	name: userString('validations:Required'),
	type: defaulted(KeywordListDto, 'standard'),
	list: withMessage(parsableArray(string()), 'validations:Required'),
});

export const EditKeywordDto = partial(AddKeywordDto);

export type ViewKeywordDto = Infer<typeof ViewKeywordDto>;
export type AddKeywordDto = Infer<typeof AddKeywordDto>;
export type EditKeywordDto = Infer<typeof EditKeywordDto>;
